<template>
  <b-row v-if="itemsCount">
    <p
      v-if="selectedRowCount"
      data-test="selection-pagination"
      class="ml-5 mt-1 mr-auto small"
    >
      {{ firstItemIndexOnPage }} - {{ lastItemIndexOnPage }} of {{ itemsCount }} {{ itemsName }} ({{ selectedRowCount }} Selected)
    </p>
    <p
      v-else
      data-test="selection-pagination"
      class="ml-5 mt-1 mr-2 small"
    >
      {{ firstItemIndexOnPage }} - {{ lastItemIndexOnPage }} of {{ itemsCount }} {{ itemsName }}
    </p>
    <p
      v-if="!hidePageSelect"
      class="d-inline-block mx-md-6 small"
    >
      <span>Show</span>
      <b-form-select
        class="mx-2 w-auto"
        v-model="perPageSelectedValue"
        data-test="tracker-per-page"
        :options="perPageNumberOptions"
        size="sm"
        :disabled="disabled"
      />
      <span>per page</span>
    </p>
    <b-pagination
      :class="['ml-auto bg-white mr-5', {'cursor-not-allowed' : disabled}]"
      size="sm"
      :total-rows="itemsCount"
      data-test="tracker-pagination"
      v-model="currentPageValue"
      @change="updateSelectedPage($event)"
      :per-page="perPageSelected"
      limit="5"
      :disabled="disabled"
    />
  </b-row>
</template>

<script>
import paginationMixin from '@/core/mixins/pagination';

export default {
  name: 'BasePagination',

  mixins: [paginationMixin],

  props: {
    itemsCount: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    perPageSelected: {
      type: Number,
      required: true,
    },
    hidePageSelect: {
      type: Boolean,
      default: false,
    },
    selectedRowCount: {
      type: Number,
      default: null,
    },
    itemsName: {
      type: String,
      required: true,
    },
    pageNumberOptions: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    perPageNumberOptions() {
      return this.pageNumberOptions.map((pageNumberOption) => ({
        text: `${pageNumberOption}`,
        value: pageNumberOption,
      }));
    },

    firstItemIndexOnPage() {
      return this.calculatePageOffset(this.currentPage, this.perPageSelected);
    },

    lastItemIndexOnPage() {
      const numberOfItems = this.itemsCount;
      const numberToDisplay = this.currentPage * this.perPageSelected;
      if (numberOfItems < this.perPageSelected || numberToDisplay > numberOfItems) {
        return this.itemsCount;
      }
      return this.currentPage * this.perPageSelected;
    },

    currentPageValue: {
      get() {
        return this.currentPage;
      },
      set(value) {
        const { perPageSelected } = this;
        this.$emit('pagingUpdate', { page: value, perPageSelected });
        this.$emit('update:currentPage', value);
      },
    },

    perPageSelectedValue: {
      get() {
        return this.perPageSelected;
      },
      set(value) {
        const { currentPage } = this;
        this.$emit('pagingUpdate', { page: currentPage, perPageSelected: value });
        this.$emit('update:perPageSelected', value);
      },
    },
  },
  methods: {
    updateSelectedPage() {
      this.$emit('change');
    },
  },
};
</script>
